"use client";

import { useRef, useState } from "react";

interface VideoSectionProps {
  src: string;
  poster?: string; // optional poster image
  className?: string; // extra custom styles
}

export default function VideoPlayer({
  src,
  poster,
  className,
}: VideoSectionProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    if (!videoRef.current) return;

    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  return (
    <section
      className={` py-16 lg:py-24  relative overflow-hidden ${className || ""}`}
    >
      <div className="relative   mx-auto ">
        <div className="mx-auto relative">
          {/* Video Container */}
          <div className="relative 2xl:w-[800px] 2xl:h-[800px] w-[600px] h-[500px]  mx-auto overflow-hidden border border-[#ccc]/12 rounded-lg p-4 shadow-xs">
            <video
              ref={videoRef}
              className=" cursor-pointer w-full h-full object-cover"
              poster={poster}
              onClick={togglePlay}
              onEnded={() => setIsPlaying(false)}
              playsInline // Added this attribute
            >
              <source src={src} type="video/mp4" />
              Your browser does not support the video tag.
            </video>

            {/* Play Button Overlay */}
            {!isPlaying && (
              <button
                onClick={togglePlay}
                className="absolute inset-0 flex items-center justify-center"
                aria-label="Play video"
              >
                <div className="bg-white bg-opacity-80 rounded-full p-6 hover:bg-opacity-100 transition">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-16 w-16 text-black"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </div>
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}